// extracted by mini-css-extract-plugin
module.exports = {"checkBoxCell":"CheckCell_checkBoxCell__1Io7y","group":"CheckCell_group__2s0tF","labelWrapper":"CheckCell_labelWrapper__3dN3E"};